import getActions from "./actionsPopupUtils";

const agent_attorney_actions = (formName, isSubaccount) => {
  return getActions({
    formName,
    isSubaccount,
    shared: false,
    subNoun: "individual profiles",
    mainNoun: "attorney/agent",
  });
};

export default agent_attorney_actions;
